export default "__VITE_ASSET__DbZ2Lxl3__"